import { lazy } from 'react';

// `React.lazy` que se recupera sozinho de deploy novo com a aba aberta.
//
// Cada página é um chunk com hash no nome (ex. Painel2.a1b2c3.chunk.js). Se
// houve deploy depois que a aba abriu, o index.html em memória ainda aponta
// pros hashes antigos, que não existem mais no servidor — o import falha
// (ChunkLoadError) e, sem isto, a tela ficava branca até um F5. Aqui, ao
// detectar esse erro, recarrega a página UMA vez (mesma URL, então a pessoa
// cai onde clicou, já com o index.html novo). Trava de 10s no sessionStorage
// pra não entrar em laço se o chunk continuar faltando depois do reload —
// nesse caso o erro sobe pro ErrorBoundary (App.jsx), que mostra a tela de
// "Algo deu errado" com botão de recarregar.
const CHAVE_RELOAD = 'chunkReloadEm';
const JANELA_MS = 10000;

function ehErroDeChunk(err) {
  if (!err) return false;
  if (err.name === 'ChunkLoadError') return true;
  // Chunk respondido com HTML (fallback do servidor) ou falha de rede ao
  // buscar o módulo — mensagens variam por navegador.
  return /Loading (CSS )?chunk|dynamically imported module|Importing a module script failed|Unexpected token '<'/i.test(err.message || '');
}

function podeRecarregar() {
  try {
    const ultimo = Number(sessionStorage.getItem(CHAVE_RELOAD) || 0);
    if (Date.now() - ultimo < JANELA_MS) return false;
    sessionStorage.setItem(CHAVE_RELOAD, String(Date.now()));
    return true;
  } catch (e) {
    // sessionStorage indisponível (modo privado/bloqueado): sem trava não dá
    // pra garantir que não entra em laço — deixa o ErrorBoundary tratar.
    return false;
  }
}

export function lazyComRetry(factory) {
  return lazy(() => factory().catch(err => {
    if (ehErroDeChunk(err) && podeRecarregar()) {
      window.location.reload();
      // Nunca resolve: o reload já está em andamento, o Suspense segue no
      // fallback ("Carregando…") até a página nova subir.
      return new Promise(() => {});
    }
    throw err;
  }));
}
